export default __webpack_public_path__ + "static/Hiding-b80c26e6e2b994819c34d86d14b7bebc.jpeg";